import { v4 as uuidv4 } from 'uuid';
import API from '../Config/Api';
import { getVisitorKey } from './visitorKey';

/**
 * A visitor who arrives from a link Social posted — `?ref=social&sp=<post id>` — is recorded once per visit
 * (POST /social/click, with the visitor key as ads do), so a booking or an order they place within 30 days can be
 * counted as what Social brought. Fire-and-forget: never blocks rendering, never throws. The `ref=social` prefill of
 * the booking page is untouched.
 *
 * Called from the same place as maybeRecordAdLanding (api/storeApi getSalonBySlug), so a landing straight onto any
 * storefront page is recorded.
 */
export function maybeRecordSocialLanding(salonId) {
  if (!salonId || typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search || '');
    if (params.get('ref') !== 'social') return;
    const sp = params.get('sp');
    const postRef = sp && /^[a-f0-9]{32}$/.test(sp) ? sp : null;
    const key = `stylon_socialclick_${salonId}_${postRef || ''}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    const visitorKey = getVisitorKey();
    if (!visitorKey) return;
    Promise.resolve(
      API.post('/social/click', {
        salonId,
        clickId: uuidv4(),
        visitorKey,
        ...(postRef ? { postRef } : {}),
      }),
    ).catch(() => {});
  } catch (_) {
    /* never throw from instrumentation */
  }
}
